import { TableRow, TableCell } from '@mui/material';
//
import { Label } from '@/components';
import { TableRowLink } from '@/components/table';
// utils
import { fCurrency } from '@/utils/formatNumber';
import { fDate } from '@/utils/formatTime';
import { providersPath } from '../../routes/paths';
import { clientManagementPath } from '@/features/users/clients';
import { bookingsManagementPath } from '@/features/bookings-management';
import { returnSessionFilterFromDate } from '@/features/bookings-management/utils/bookingSessions';
//
import type { ProviderJob } from '../../types';

type ProviderJobsRowProps = {
  row: ProviderJob;
};

const formatProviderIncome = (value?: number | string | null) => {
  if (value === null || value === undefined || value === '') return 'N/A';

  const normalizedValue = typeof value === 'string' ? value.trim() : value;
  if (normalizedValue === '') return 'N/A';

  const numericValue = Number(normalizedValue);
  return Number.isFinite(numericValue) ? fCurrency(numericValue) : 'N/A';
};

export default function ProviderJobsTableRow({ row }: ProviderJobsRowProps) {
  const {
    id,
    booking_id,
    user,
    date,
    booking_session_cleaners,
    booking_cleaners,
    provider_income,
    provider_paid,
  } = row;

  const client = `${user?.first_name ?? 'N/A'} ${user?.last_name ?? 'N/A'}`;
  const assignedTo = booking_session_cleaners ?? booking_cleaners ?? [];
  const jobLink = bookingsManagementPath('view', {
    bookingId: String(booking_id),
    bookingTabSid: 'booking-sessions',
    sessionFilter: `${returnSessionFilterFromDate(date)}?sessionID=${id}`,
  });

  return (
    <>
      <TableRow hover>
        <TableCell width={10} />

        {/* ID */}
        <TableCell align="left">
          <TableRowLink linkText={id} linkTo={jobLink} />
        </TableCell>

        {/* CLIENT */}
        <TableCell align="left">
          <TableRowLink
            linkText={client}
            linkTo={clientManagementPath('edit', {
              userId: String(user.id),
              tabSid: 'details',
            })}
          />
        </TableCell>

        {/* EMAIL */}
        <TableCell align="left">
          <TableRowLink
            linkText={user?.email ?? 'N/A'}
            linkTo={`mailto:${user?.email}`}
          />
        </TableCell>

        {/* ASSIGNED TO */}
        <TableCell align="left">
          <TableRowLink
            linkText={`${assignedTo[0]?.first_name} ${assignedTo[0]?.last_name}`}
            linkTo={providersPath('edit', {
              userId: String(assignedTo[0]?.id || 0),
              tabSid: 'details',
            })}
          />
        </TableCell>

        {/* PROVIDER INCOME */}
        <TableCell align="left">
          {formatProviderIncome(provider_income)}
        </TableCell>

        {/* PAYMENT STATUS */}
        <TableCell align="left">
          <Label color={provider_paid ? 'success' : 'error'}>
            {provider_paid ? 'Paid' : 'Unpaid'}
          </Label>
        </TableCell>

        <TableCell align="left">{fDate(date, 'EE, dd MMM yy')}</TableCell>
      </TableRow>
    </>
  );
}
